import { eventKeyUpDebounceUpdateContent } from "../helpers/updateContent.js";

export function initKeyboardEvents() {
	eventKeyUpDebounceUpdateContent();
}
